export const formatUtcDateToLocalString = (dateValue: string | Date): string => {
  const date = new Date(dateValue ?? '');

  if (isNaN(date.getTime())) {
    return '';
  }

  const utcDate = new Date(Date.UTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds()
  ));

  return utcDate.toLocaleString();
};